import { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { Bar } from "./FFPublic";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/ff/admin`;
const TK = "ff_admin_token";

const authAxios = () => axios.create({ baseURL: API, headers: { Authorization: `Bearer ${localStorage.getItem(TK)}` } });

export default function FFAdmin() {
  const [token, setToken] = useState(localStorage.getItem(TK) || "");
  const [email, setEmail] = useState(""); const [pw, setPw] = useState(""); const [err, setErr] = useState("");
  const [tab, setTab] = useState("dashboard");
  const [dash, setDash] = useState(null); const [cfg, setCfg] = useState(null);
  const [ruolo, setRuolo] = useState(""); const [msg, setMsg] = useState("");
  const timer = useRef(null);

  const logout = useCallback(() => { localStorage.removeItem(TK); setToken(""); setDash(null); }, []);
  const resetTimer = useCallback(() => { clearTimeout(timer.current); timer.current = setTimeout(logout, 30 * 60 * 1000); }, [logout]);

  const loadDash = useCallback(async () => {
    try { const { data } = await authAxios().get(`/dashboard`, { params: ruolo ? { ruolo } : {} }); setDash(data); }
    catch (e) { if (e.response?.status === 401) logout(); }
  }, [ruolo, logout]);
  const loadCfg = useCallback(async () => { try { const { data } = await authAxios().get(`/config`); setCfg(data); } catch { /* */ } }, []);

  useEffect(() => {
    if (!token) return;
    resetTimer(); loadDash(); loadCfg();
    const ev = ["click", "keydown", "mousemove"]; const h = () => resetTimer();
    ev.forEach((e) => window.addEventListener(e, h)); return () => ev.forEach((e) => window.removeEventListener(e, h));
  }, [token, resetTimer, loadDash, loadCfg]);
  useEffect(() => { if (token) loadDash(); }, [ruolo, token, loadDash]);

  const doLogin = async () => {
    setErr("");
    try { const { data } = await axios.post(`${API}/login`, { email, password: pw }); localStorage.setItem(TK, data.token); setToken(data.token); }
    catch (e) { setErr(e.response?.data?.detail || "Accesso non riuscito"); }
  };
  const download = async (path, name) => {
    const { data } = await authAxios().get(path, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([data])); const a = document.createElement("a"); a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url);
  };
  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(""), 2500); };

  if (!token) return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl border p-8 w-full max-w-sm" data-testid="ff-admin-login">
        <h1 className="text-xl font-bold mb-1">Fabbisogno Formativo 2027–2029</h1>
        <p className="text-sm text-slate-500 mb-5">Area amministrazione</p>
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="border rounded-lg p-2.5 w-full mb-2" data-testid="ff-login-email" />
        <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} onKeyDown={(e) => e.key === "Enter" && doLogin()} placeholder="Password" className="border rounded-lg p-2.5 w-full mb-3" data-testid="ff-login-pw" />
        {err && <p className="text-red-600 text-sm mb-2" data-testid="ff-login-err">{err}</p>}
        <button onClick={doLogin} className="bg-blue-600 text-white w-full py-2.5 rounded-lg" data-testid="ff-login-btn">Accedi</button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50" data-testid="ff-admin">
      <div className="bg-white border-b px-4 py-3 flex items-center justify-between">
        <b>Fabbisogno Formativo — Amministrazione</b>
        <div className="flex gap-2 items-center text-sm">
          {[["dashboard", "Cruscotto"], ["impostazioni", "Impostazioni"], ["risposte", "Risposte"], ["domande", "Domande"], ["admin", "Amministratori"]].map(([t, lbl]) => <button key={t} onClick={() => setTab(t)} className={`px-3 py-1.5 rounded ${tab === t ? "bg-blue-600 text-white" : "text-slate-600"}`} data-testid={`ff-tab-${t}`}>{lbl}</button>)}
          <button onClick={logout} className="text-slate-500" data-testid="ff-logout">Esci</button>
        </div>
      </div>
      {msg && <div className="bg-emerald-50 text-emerald-700 text-sm px-4 py-2">{msg}</div>}
      <div className="max-w-5xl mx-auto p-4">
        {tab === "dashboard" && dash && (
          <div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5">
              <Kpi label="Risposte totali" v={dash.totale} />
              <Kpi label="Giorni alla scadenza" v={dash.giorni_mancanti ?? "—"} />
              <div className="bg-white border rounded-xl p-3">
                <div className="text-xs text-slate-500 mb-1">Filtra per ruolo</div>
                <select value={ruolo} onChange={(e) => setRuolo(e.target.value)} className="border rounded p-1.5 w-full text-sm" data-testid="ff-filter-ruolo">
                  <option value="">Tutti</option>
                  {(dash.per_ruolo || []).map((r) => <option key={r.opzione} value={r.opzione}>{r.opzione} ({r.n})</option>)}
                </select>
              </div>
            </div>
            {dash.sotto_soglia ? <p className="text-amber-600" data-testid="ff-sotto-soglia">{dash.messaggio}</p> : (
              <div className="grid md:grid-cols-2 gap-5">
                <Card t="Ruoli (D1)">{dash.per_ruolo.map((r) => <Bar key={r.opzione} label={r.opzione} n={r.n} perc={r.perc} color="#2563EB" />)}</Card>
                <Card t="Classifica generale fabbisogni">{dash.classifica.slice(0, 12).map((c, i) => <div key={i} className="flex justify-between text-sm py-0.5"><span>{c.tema} <span className="text-slate-400 text-xs">{c.origine}</span></span><b>{c.n}</b></div>)}</Card>
                <Card t="D2 Relazionali">{dash.d2.map((r) => <Bar key={r.opzione} label={r.opzione} n={r.n} perc={r.perc} color="#0ea5e9" />)}</Card>
                <Card t="D3 Normativa (indice priorità)">{dash.d3.map((d) => <div key={d.tema} className="text-sm py-0.5 flex justify-between"><span>{d.tema}</span><b>{d.indice}</b></div>)}</Card>
                <Card t="D4 Professionali">{dash.d4.map((r) => <Bar key={r.opzione} label={r.opzione} n={r.n} perc={r.perc} color="#16a34a" />)}</Card>
                <Card t="D5 Amministrative">{dash.d5.map((r) => <Bar key={r.opzione} label={r.opzione} n={r.n} perc={r.perc} color="#9333ea" />)}</Card>
                <Card t="Risposte aperte D7">{dash.aperte.d7.length ? dash.aperte.d7.map((x, i) => <p key={i} className="text-sm border-b py-1">{x}</p>) : <p className="text-sm text-slate-400">Nessuna</p>}</Card>
                <Card t="Risposte aperte D8">{dash.aperte.d8.length ? dash.aperte.d8.map((x, i) => <p key={i} className="text-sm border-b py-1">{x}</p>) : <p className="text-sm text-slate-400">Nessuna</p>}</Card>
              </div>
            )}
            <div className="flex flex-wrap gap-2 mt-5">
              <button onClick={() => download("/export/xlsx", "fabbisogno.xlsx")} className="border px-3 py-2 rounded text-sm" data-testid="ff-exp-xlsx">Export Excel</button>
              <button onClick={() => download("/export/csv", "fabbisogno.csv")} className="border px-3 py-2 rounded text-sm">Export CSV</button>
              <button onClick={() => download("/export/pdf", "cruscotto.pdf")} className="border px-3 py-2 rounded text-sm" data-testid="ff-exp-pdf">PDF cruscotto</button>
              <button onClick={async () => { await authAxios().post("/demo/seed"); flash("30 risposte di prova create"); loadDash(); }} className="border px-3 py-2 rounded text-sm text-blue-600" data-testid="ff-demo-seed">Genera 30 prova</button>
              <button onClick={async () => { await authAxios().delete("/demo"); flash("Prove eliminate"); loadDash(); }} className="border px-3 py-2 rounded text-sm">Cancella prove</button>
            </div>
          </div>
        )}
        {tab === "impostazioni" && cfg && (
          <div className="bg-white border rounded-xl p-4 max-w-lg space-y-3" data-testid="ff-settings">
            <Field l="Titolo"><input value={cfg.titolo || ""} onChange={(e) => setCfg({ ...cfg, titolo: e.target.value })} className="border rounded p-2 w-full" /></Field>
            <Field l="Testo introduttivo"><textarea rows={3} value={cfg.intro || ""} onChange={(e) => setCfg({ ...cfg, intro: e.target.value })} className="border rounded p-2 w-full" /></Field>
            <div className="flex gap-3">
              <Field l="Apertura"><input type="date" value={cfg.data_apertura || ""} onChange={(e) => setCfg({ ...cfg, data_apertura: e.target.value })} className="border rounded p-2" /></Field>
              <Field l="Scadenza"><input type="date" value={cfg.data_scadenza || ""} onChange={(e) => setCfg({ ...cfg, data_scadenza: e.target.value })} className="border rounded p-2" /></Field>
            </div>
            <label className="flex items-center gap-2"><input type="checkbox" checked={!!cfg.aperto} onChange={(e) => setCfg({ ...cfg, aperto: e.target.checked })} data-testid="ff-aperto" /> Questionario aperto</label>
            <Field l="Colore principale"><input type="color" value={cfg.colore || "#2563EB"} onChange={(e) => setCfg({ ...cfg, colore: e.target.value })} /></Field>
            <button onClick={async () => { await authAxios().put("/config", cfg); flash("Impostazioni salvate"); }} className="bg-blue-600 text-white px-4 py-2 rounded" data-testid="ff-save-cfg">Salva</button>
            <div className="pt-3 border-t">
              <div className="text-sm font-medium mb-1">Link pubblico compilatori</div>
              <input readOnly value={`${window.location.origin}/fabbisogno-formativo`} className="border rounded p-2 w-full text-sm" data-testid="ff-public-link" />
              <img alt="qr" className="mt-2 border rounded" src={`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(`${window.location.origin}/fabbisogno-formativo`)}`} />
            </div>
          </div>
        )}
        {tab === "risposte" && <RisposteTab flash={flash} loadDash={loadDash} />}
        {tab === "domande" && <DomandeTab flash={flash} loadDash={loadDash} />}
        {tab === "admin" && <AdminsTab flash={flash} meEmail={null} />}
      </div>
    </div>
  );
}

const Kpi = ({ label, v }) => <div className="bg-white border rounded-xl p-3" data-testid="ff-kpi"><div className="text-xs text-slate-500">{label}</div><div className="text-2xl font-bold">{v}</div></div>;
const Card = ({ t, children }) => <div className="bg-white border rounded-xl p-4"><div className="font-semibold mb-2 text-sm">{t}</div>{children}</div>;
const Field = ({ l, children }) => <div><div className="text-xs text-slate-500 mb-1">{l}</div>{children}</div>;

function RisposteTab({ flash, loadDash }) {
  const [rows, setRows] = useState([]); const [conf, setConf] = useState("");
  const load = useCallback(() => { authAxios().get("/responses").then((r) => setRows(r.data)); }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="bg-white border rounded-xl p-4" data-testid="ff-risposte">
      <div className="flex justify-between items-center mb-3">
        <b>{rows.length} risposte</b>
        <div className="flex gap-2 items-center">
          <input value={conf} onChange={(e) => setConf(e.target.value)} placeholder='Scrivi ELIMINA' className="border rounded p-1.5 text-sm" />
          <button onClick={async () => { try { await authAxios().post("/responses/delete-all", { conferma: conf }); flash("Tutte eliminate"); setConf(""); load(); loadDash(); } catch (e) { flash(e.response?.data?.detail || "Errore"); } }} className="border border-red-300 text-red-600 px-3 py-1.5 rounded text-sm" data-testid="ff-del-all">Elimina tutte</button>
        </div>
      </div>
      <div className="max-h-[60vh] overflow-auto">
        {rows.map((r) => (
          <div key={r.id} className="flex justify-between items-center border-b py-1.5 text-sm">
            <span>{r.data_giorno} · {r.d1_ruolo} {r.is_demo && <span className="text-xs text-amber-600">(prova)</span>}</span>
            <button onClick={async () => { await authAxios().delete(`/responses/${r.id}`); load(); loadDash(); }} className="text-red-500 text-xs" data-testid={`ff-del-${r.id}`}>Elimina</button>
          </div>
        ))}
      </div>
    </div>
  );
}


// ---------------------------------------------------------------- Domande (editabili)
const Q_META = [
  ["ruoli", "D1 · Ruoli / professioni", "Una voce per riga. Tieni sempre 'Altro' se vuoi il campo libero."],
  ["d2", "D2 · Competenze relazionali (scelte 1–2)", "Una voce per riga."],
  ["d3", "D3 · Temi normativi (righe da valutare)", "Una voce per riga: ognuna avrà le valutazioni sotto."],
  ["d3_val", "D3 · Scala di valutazione", "Dalla meno prioritaria (in alto) alla più prioritaria (in basso). Min. 2 voci."],
  ["d4", "D4 · Competenze professionali (scelte 1–3)", "Una voce per riga."],
  ["d5", "D5 · Formazione amministrativa/tecnica (0–3)", "Una voce per riga."],
  ["d6a", "D6a · Modalità", "Una voce per riga."],
  ["d6b", "D6b · Metodologia", "Una voce per riga."],
  ["d6c", "D6c · Tempi", "Una voce per riga."],
];

function DomandeTab({ flash, loadDash }) {
  const [q, setQ] = useState(null);
  const [reali, setReali] = useState(0);
  const [saving, setSaving] = useState(false);
  const load = useCallback(() => {
    authAxios().get("/questions").then((r) => { setQ(r.data.questions); setReali(r.data.risposte_reali); });
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!q) return <p className="text-sm text-slate-500">Caricamento…</p>;
  const setField = (k, text) => setQ({ ...q, [k]: text.split("\n") });
  const save = async () => {
    setSaving(true);
    try {
      const clean = {}; Q_META.forEach(([k]) => { clean[k] = (q[k] || []).map((x) => String(x).trim()).filter(Boolean); });
      await authAxios().put("/questions", { questions: clean });
      flash("Domande salvate"); load(); loadDash();
    } catch (e) { flash(e.response?.data?.detail || "Errore nel salvataggio"); }
    setSaving(false);
  };
  const reset = async () => {
    if (!window.confirm("Ripristinare le domande predefinite? Le modifiche ai testi andranno perse.")) return;
    await authAxios().post("/questions/reset"); flash("Domande ripristinate"); load(); loadDash();
  };
  return (
    <div className="bg-white border rounded-xl p-4 max-w-3xl space-y-4" data-testid="ff-domande">
      <div className="flex items-center justify-between">
        <b>Testi del questionario</b>
        <div className="flex gap-2">
          <button onClick={reset} className="border px-3 py-1.5 rounded text-sm" data-testid="ff-domande-reset">Ripristina predefinite</button>
          <button onClick={save} disabled={saving} className="bg-blue-600 text-white px-4 py-1.5 rounded text-sm disabled:opacity-50" data-testid="ff-domande-save">{saving ? "Salvo…" : "Salva domande"}</button>
        </div>
      </div>
      {reali > 0 && <div className="bg-amber-50 border border-amber-200 text-amber-700 text-sm rounded p-2" data-testid="ff-domande-warn">
        Attenzione: ci sono già {reali} risposte reali. Se rinomini o rimuovi delle voci, le statistiche delle voci modificate non corrisponderanno più alle risposte già raccolte. Meglio modificare i testi prima di aprire la rilevazione.
      </div>}
      {Q_META.map(([k, label, help]) => (
        <div key={k}>
          <div className="text-sm font-semibold">{label}</div>
          <div className="text-xs text-slate-500 mb-1">{help}</div>
          <textarea data-testid={`ff-q-${k}`} rows={Math.min(14, Math.max(3, (q[k] || []).length + 1))} value={(q[k] || []).join("\n")} onChange={(e) => setField(k, e.target.value)} className="border rounded p-2 w-full text-sm font-mono" />
        </div>
      ))}
      <p className="text-xs text-slate-400">Suggerimento: mantieni una voce “Altro” dove vuoi consentire una risposta libera.</p>
    </div>
  );
}

// ---------------------------------------------------------------- Amministratori
function AdminsTab({ flash }) {
  const [rows, setRows] = useState([]);
  const [nome, setNome] = useState(""); const [email, setEmail] = useState(""); const [pw, setPw] = useState("");
  const load = useCallback(() => { authAxios().get("/admins").then((r) => setRows(r.data)).catch(() => flash("Errore nel caricamento amministratori")); }, [flash]);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    try { await authAxios().post("/admins", { nome, email, password: pw }); flash("Amministratore aggiunto"); setNome(""); setEmail(""); setPw(""); load(); }
    catch (e) { flash(e.response?.data?.detail || "Errore"); }
  };
  const del = async (id) => {
    if (!window.confirm("Rimuovere questo amministratore?")) return;
    try { await authAxios().delete(`/admins/${id}`); flash("Rimosso"); load(); }
    catch (e) { flash(e.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="bg-white border rounded-xl p-4 max-w-xl space-y-4" data-testid="ff-admins">
      <div>
        <b>Amministratori ({rows.length}/3)</b>
        <p className="text-xs text-slate-500 mt-1">Ogni amministratore ha gli stessi poteri: può vedere i risultati, esportare e modificare le domande. L'accesso è isolato dagli utenti della Suite.</p>
      </div>
      <div className="divide-y border rounded">
        {rows.map((a) => (
          <div key={a.id} className="flex items-center justify-between px-3 py-2 text-sm" data-testid={`ff-admin-row-${a.id}`}>
            <div><b>{a.nome || "—"}</b> · {a.email}<div className="text-xs text-slate-400">Ultimo accesso: {a.last_login ? new Date(a.last_login).toLocaleString("it-IT") : "mai"}</div></div>
            <button onClick={() => del(a.id)} className="text-red-500 text-xs" data-testid={`ff-admin-del-${a.id}`}>Rimuovi</button>
          </div>
        ))}
      </div>
      {rows.length < 3 ? (
        <div className="border-t pt-3 space-y-2">
          <div className="text-sm font-semibold">Aggiungi amministratore secondario</div>
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome (facoltativo)" className="border rounded p-2 w-full text-sm" data-testid="ff-admin-nome" />
          <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="border rounded p-2 w-full text-sm" data-testid="ff-admin-email" />
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Password (min 6 caratteri)" className="border rounded p-2 w-full text-sm" data-testid="ff-admin-pw" />
          <button onClick={add} className="bg-blue-600 text-white px-4 py-2 rounded text-sm" data-testid="ff-admin-add">Aggiungi</button>
        </div>
      ) : <p className="text-sm text-amber-600">Raggiunto il massimo di 3 amministratori.</p>}
    </div>
  );
}
